var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products.length > 0
    ? _c(
        "section",
        {
          class: _vm.bemBlock,
          attrs: {
            "data-context": _vm.tileContext,
            "data-location": _vm.locationForAnalytics
          }
        },
        [
          _vm.heading
            ? _c("p", { class: _vm.bemElement("heading") }, [
                _vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "swiper",
              class: [_vm.bemElement("slider"), "swiper", "u-scrollbar-none"],
              attrs: { itemtype: "http://schema.org/SomeProducts" }
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.products, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: "product-slider-" + index,
                      staticClass: "swiper-slide",
                      class: _vm.bemElement("item")
                    },
                    [
                      _c("BaseProductTile", {
                        attrs: {
                          analytics: _vm.buildAnalyticsPropForProduct(index),
                          context: _vm.tileContext,
                          keyid: item.product.id + "-" + index,
                          "grid-index": index,
                          "has-carousel": _vm.isBreakpointDesktop,
                          "hide-tags": _vm.hideTileTags,
                          "show-swatches": false,
                          product: item.product,
                          url: item.urls.product,
                          "is-recommendation-from-einstein":
                            _vm.isRecommendationFromEinstein
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }